<template>
  <div class='animated fadeIn'>
    <div class='d-flex justify-content-center'>
      <b-card v-if="user && user.role == 'user'" class='shadow-sm rounded mb-1' bg-variant='transparent' border-variant='white' title='私の目的・目標' text-variant='danger' align='center'>
        <croppa v-model='myCroppa'
          :initial-image='initialImage'
          crossOrigin='anonymous'
          :auto-sizing='true'
          :width='256'
          :height='256'
          placeholder='目標設定画像を選択'
          :placeholder-font-size='14'
          :accept="'image/*'"></croppa>
        <div class='d-flex justify-content-center m-0 p-0'>
          <b-button class='submit-btn' variant='danger' v-b-modal.modal-center>更新</b-button>
          <b-modal id='modal-center'
                  ref='modal'
                  title='目標設定画像'
                  @ok='storeData'
                  centered
                  header-bg-variant='danger'
                  body-text-variant='danger'
                  ok-variant='danger'
                  size='sm'>
            <p class='my-4'>画像を更新します</p>
            <p class='my-4'>よろしいですか?</p>
          </b-modal>
        </div>
      </b-card>
    </div>
    <div class='d-flex justify-content-center m-0 p-0'>
      <b-card v-if="user && user.role == 'user'" class='shadow-sm rounded' bg-variant='transparent' border-variant='white' title='私のスローガン' text-variant='primary' align='center' style='width:298px;'>
        <el-alert v-if='user.status != ""'
          :title='user.status'
          type="primary"
          center
          :closable="false">
        </el-alert>
      </b-card>
    </div>
    <b-modal ref='errorModal' centered title='エラー' class='text-primary' size="sm" ok-variant=primary header-bg-variant=primary>
      <p class='my-4'>{{errorMessage}}</p>
    </b-modal>

    <b-button v-if="needRegister" class='submit-btn' variant='danger' v-b-modal.modal-regist>メールアドレス登録</b-button>
    <b-modal
      id='modal-regist'
      ref='testModal'
      title='メールアドレス・ログイン登録'
      centered
      header-bg-variant='danger'
      header-text-variant='white'
      body-text-variant='danger'
      ok-variant='danger'
      size='medium'
      class='px100-btn'
      @ok="registEmail"
      style='text-align:left;'>
      <el-input disabled class='mb-3' size='medium' type='email' placeholder='メールアドレス' name='username' v-model='username'>
        <template slot="prepend"><i class="fas fa-envelope"></i></template>
      </el-input>
      <el-input class='mb-3' size='medium' type='password' placeholder='パスワード' name='password' v-model='password'>
        <template slot="prepend"><i class="fas fa-unlock-alt"></i></template>
      </el-input>
      <el-input class='mb-3' size='medium' type='password' placeholder='パスワード（繰り返し）' name='password' v-model='repeatPassword'>
        <template slot="prepend"><i class="fas fa-unlock-alt"></i></template>
      </el-input>
      <p>Facebook / Googleによるログインは、2021年6月30日をもって廃止されメールアドレスでのログインのみとなります。</p>
    </b-modal>
    <b-modal ref='errorModal2' centered title='エラー' class='text-primary' size="sm" ok-variant=danger header-bg-variant=danger>
      <p class='my-4'>{{errorMessage}}</p>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/auth'
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  data: () => {
    return {
      myCroppa: null,
      unwatch0: null,
      unwatch2: null,
      isLoading: false,
      initialImage: null,
      fsImage: null,
      errorMessage: '',
      dialog: false,
      username: null,
      password: null,
      repeatPassword: null,
      needRegister: false
    }
  },
  created () {
    var vm = this
    const db = firebase.firestore()
    const settings = { timestampsInSnapshots: true }
    db.settings(settings)

    if (this.init) {
      var dbRef = db.collection('images').doc(this.user.key).collection('data').doc('goal_image')
      vm.unwatch2 = dbRef.onSnapshot(function (doc) {
        if (doc.exists) {
          vm.fsImage = doc.data()
          vm.initialImage = doc.data().icon
          vm.myCroppa.refresh()
        }
      })
    } else {
      this.unwatch0 = this.$store.watch(state => this.$store.getters['authUser/init'], value => {
        var dbRef = db.collection('images').doc(this.user.key).collection('data').doc('goal_image')
        vm.unwatch2 = dbRef.onSnapshot(function (doc) {
          if (doc.exists) {
            vm.fsImage = doc.data()
            vm.initialImage = doc.data().icon
            vm.myCroppa.refresh()
          }
        })
      })
    }
  },
  beforeDestroy () {
    if (this.unwatch0) {
      this.unwatch0()
      this.unwatch0 = null
    }
    if (this.unwatch2) {
      this.unwatch2()
      this.unwatch2 = null
    }
  },
  watch: {
    init () {
      var providerData = firebase.auth().currentUser.providerData
      this.needRegister = this.checkProvider(providerData)
      if (this.needRegister) {
        this.$refs.testModal.show()
      }
      this.username = firebase.auth().currentUser.email
      // for (var i in providerData) {
      //   if (providerData[i].providerId.indexOf('password') === -1) {
      //     this.needRegister = true
      //     this.$refs.testModal.show()
      //   }
      // }
    }
  },
  methods: {
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    writeuser () {
      var vm = this
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      const batch = db.batch()
      var refImage = db.collection('images').doc(this.user.key).collection('data').doc('goal_image')
      batch.set(refImage, vm.fsImage)
      batch.commit().then(function () {
      })
    },
    checkProvider () {
      var providerData = firebase.auth().currentUser.providerData
      var status = true
      for (var i in providerData) {
        if (providerData[i].providerId.indexOf('password') !== -1) {
          status = false
        }
      }
      return status
    },
    registEmail () {
      var vm = this
      if (!this.username) {
        this.errorMessage = 'メールアドレスを入力してください'
        this.$refs.errorModal2.show()
        return
      }
      if (!this.password || !this.repeatPassword) {
        this.errorMessage = 'パスワードを入力してください'
        this.$refs.errorModal2.show()
        return
      }
      if (this.password !== this.repeatPassword) {
        this.errorMessage = 'パスワードが一致しません'
        this.$refs.errorModal2.show()
        return
      }
      var credential = firebase.auth.EmailAuthProvider.credential(this.username, this.password)
      firebase.auth().currentUser.linkAndRetrieveDataWithCredential(credential)
        .then(function (usercred) {
          var user = usercred.user
          vm.needRegister = vm.checkProvider(user)
          console.log('Account linking success', user)
        }).catch(function (error) {
          console.log('Account linking error', error)
        })
    },
    storeData () {
      var vm = this
      this.myCroppa.generateBlob((blob) => {
        if (blob) {
          var uuid = this.generateUuid()
          var storageRef = firebase.storage().ref().child('users').child(this.user.key).child(uuid)
          var uploadTask = storageRef.put(blob)
          uploadTask.on('state_changed', function (snapshot) {
            // var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                break
            }
          }, function (error) {
            vm.errorMessage = error.errorMessage
            vm.showModal()
          }, function () {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              if (!vm.fsImage) {
                vm.fsImage = {
                  'owner': vm.user.key,
                  'type': 'goal_image',
                  'icon': '',
                  'createdAt': parseInt(new Date().getTime() / 1000),
                  'updatedAt': parseInt(new Date().getTime() / 1000)
                }
              }
              vm.fsImage.icon = downloadURL
              vm.fsImage.updatedAt = parseInt(new Date().getTime() / 1000)
              // vm.myCroppa.remove()
              vm.writeuser()
            })
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      user: 'authUser/user',
      services: 'service/services',
      loading: 'dispatch/loading',
      init: 'authUser/init',
      auth: 'dispatch/auth',
      register: 'register/register'
    })
  }
}
</script>

<style lang='scss'>
// Basic styles are pulled in from the Bulma framework https://bulma.io/
// These style tags could be omitted as they arre not used.
</style>



// WEBPACK FOOTER //
// src/components/Home.vue